import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-refund-policy',
  templateUrl: './landing-refund-policy.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-refund-policy.component.scss']
})
export class LandingRefundPolicyComponent {

}
